.dt{padding:0.5rem;}